import * as React from 'react';
import './entranceFeeSummary.module.scss';
import { StrikeThrough } from '../format/StrikeThrough';
import { MaterialFontIcon } from '../../../../commonv3/components/atoms/icons/icons';

export const EntranceFeeSummary = ({
    name,
    price,
    priceWithTax,
    discount,
    showPlusIcon = false,
    showHeader = false,
}) => {
    const discountPrice = Math.max(price - discount, 0);
    const discountPriceWithTax = Math.max(priceWithTax - discount, 0);
    return (
        <div styleName="wrapper">
            {showPlusIcon && <MaterialFontIcon name="add" styleName="plus-icon" />}
            {showHeader && <div styleName="name">{name}</div>}
            <div styleName="summary">
                <div styleName="name">{name}</div>
                <div styleName="price-wrapper">
                    {discountPrice !== price && (
                        <StrikeThrough styleName="original-price" lineColor={'gray'}>
                            <span styleName="price-number">{price.toLocaleString()}</span>円（税込{' '}
                            {priceWithTax.toLocaleString()}円）
                        </StrikeThrough>
                    )}
                    {discountPrice !== price && (
                        <div styleName="discount">
                            <span styleName="price-number">-{discount.toLocaleString()}</span>円
                        </div>
                    )}
                    <div styleName="final-price">
                        <span styleName="final-price-number">{discountPrice.toLocaleString()}</span>円（税込{' '}
                        {discountPriceWithTax.toLocaleString()}円）
                    </div>
                </div>
            </div>
        </div>
    );
};
